import { getInfuseServices, InfuseService, InfuseServiceType } from '@infuse/api/feature';
import { useQuery } from '@tanstack/vue-query';

export const useInfuseServices = () => {
  return useQuery<InfuseService[]>({
    queryKey: ['infuse-services'],
    queryFn: async () => {
      return await getInfuseServices();
    }
  });
};

export const hasInfuseService = (services: InfuseService[] | undefined, serviceType: InfuseServiceType): boolean => {
  if (!services) {
    return false;
  }
  return services.some((service) => service.type === serviceType);
}
